import { usePostMutation } from "../../../hooks/useClientPortalQuery";
import { AxiosError } from "axios";
import { ApiErrorResponse, EmailModel } from "../../../types/generated/models";
import { useClientPortalConfigContext } from "../../../context/ClientPortalConfig.ctx";

export function useEmailInvoice() {
    const { clientPortalGuid } = useClientPortalConfigContext();
    const { mutateAsync, isPending, isError } = usePostMutation<void, AxiosError<ApiErrorResponse>, EmailModel>({
        url: `/api/v1/${clientPortalGuid}/Invoices/EmailInvoice`,
    });

    return { mutateAsync, isSendingEmail: isPending, sendEmailSuccess: !isError };
}
